import { render } from "./Heading.vue?vue&type=template&id=b44bd634&ts=true"
import script from "./Heading.vue?vue&type=script&setup=true&lang=ts"
export * from "./Heading.vue?vue&type=script&setup=true&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/js/components/Heading.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "b44bd634"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('b44bd634', __exports__)) {
    api.reload('b44bd634', __exports__)
  }
  
  module.hot.accept("./Heading.vue?vue&type=template&id=b44bd634&ts=true", () => {
    api.rerender('b44bd634', render)
  })

}


export default __exports__